import React from "react";

const NavigationDots = ({ active }) => {
    return (
        <div className="app__navigation">
            {["home", "about", "work", "skills", "testimonials", "contact"].map(
                (item, index) => (
                    <a
                        className="app__navigation-dot"
                        key={`navigation-link-${item}-${index}`}
                        href={`#${item}`}
                        style={
                            active === item
                                ? { backgroundColor: "#313BAC" }
                                : {}
                        }
                    />
                )
            )}
        </div>
    );
};

export default NavigationDots;
